export default [{
  path: '/sale/index',
  name: 'sale-index',
  title: '财务',
  component: () => import('@/views/sale/index'),
  children: [{
    path: '/sale/project',
    name: 'project-analysis',
    title: '项目分析',
    component: () => import('@/views/sale/template/project')
  }, {
    path: '/sale/product',
    name: 'product-analysis', // 产品分析
    title: '项目分析',
    component: () => import('@/views/sale/template/product')
  }, {
    path: '/sale/package',
    name: 'package-analysis', // 套餐分析
    title: '项目分析',
    component: () => import('@/views/sale/template/package')
  },
  {
    path: '/sale/employee',
    name: 'employee-analysis', // 员工分析
    title: '项目分析',
    component: () => import('@/views/sale/template/employee')
  },
  {
    path: '/sale/customer',
    name: 'customer-analysis', // 顾客分析
    title: '项目分析',
    component: () => import('@/views/sale/template/customer')
  },
  {
    path: '/sale/overview',
    name: 'overview-analysis', // 套餐分析
    title: '项目分析',
    component: () => import('@/views/sale/template/overview')
  }, {
    path: '/sale/sales',
    name: 'sales-analysis', // 套餐分析
    title: '项目分析',
    component: () => import('@/views/sale/template/sales')
  }, {
    path: '/sale/deduction',
    name: 'deduction-analysis', // 套餐分析
    title: '项目分析',
    component: () => import('@/views/sale/template/deduction')
  },
  {
    path: '/sale/giveAnalysis',
    name: 'give-analysis', // 赠送
    title: '项目分析',
    component: () => import('@/views/sale/template/giveAnalysis')
  }
  ]
}];
